/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PalAuthSubmissionStatusUpdatedByUserUserType
 */
export interface PalAuthSubmissionStatusUpdatedByUserUserType {
    /**
     * 
     * @type {string}
     * @memberof PalAuthSubmissionStatusUpdatedByUserUserType
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthSubmissionStatusUpdatedByUserUserType
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthSubmissionStatusUpdatedByUserUserType
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthSubmissionStatusUpdatedByUserUserType
     */
    description?: string;
}

/**
 * Check if a given object implements the PalAuthSubmissionStatusUpdatedByUserUserType interface.
 */
export function instanceOfPalAuthSubmissionStatusUpdatedByUserUserType(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PalAuthSubmissionStatusUpdatedByUserUserTypeFromJSON(json: any): PalAuthSubmissionStatusUpdatedByUserUserType {
    return PalAuthSubmissionStatusUpdatedByUserUserTypeFromJSONTyped(json, false);
}

export function PalAuthSubmissionStatusUpdatedByUserUserTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalAuthSubmissionStatusUpdatedByUserUserType {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'title': !exists(json, 'title') ? undefined : json['title'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'description': !exists(json, 'description') ? undefined : json['description'],
    };
}

export function PalAuthSubmissionStatusUpdatedByUserUserTypeToJSON(value?: PalAuthSubmissionStatusUpdatedByUserUserType | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'title': value.title,
        'type': value.type,
        'description': value.description,
    };
}

